import React, { useState, useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import "../css/Login.css";

const Login = () => {
  const { login, verifyOtp, authLoading } = useContext(AuthContext);
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [userId, setUserId] = useState(null);
  const [step, setStep] = useState("login"); // login -> otp
  const [error, setError] = useState("");

  // Handle login submit
  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    const result = await login(username, password);

    if (result.otpRequired) {
      setUserId(result.userId);
      setStep("otp");
    } else if (result.success) {
      navigate("/dashboard"); // redirect if login completed without OTP
    } else {
      setError(result.error || "Login failed. Please try again.");
    }
  };

  // Handle OTP verification
  const handleOtpVerify = async (e) => {
    e.preventDefault();
    setError("");

    const success = await verifyOtp(userId, otp);
    if (success) {
      navigate("/dashboard");
    } else {
      setError("Invalid OTP. Please try again.");
    }
  };

  return (
    <div className="container">
      <div className="content-wrapper">
        {/* Logo Section */}
        <div className="logo-section">
          <img src="/PRINTMYCAKE.png" alt="App Logo" />
        </div>

        {/* Form Section */}
        <div className="form-container">
          <div className="form-container-box">
            <h1 className="title">{step === "login" ? "Login" : "Verify OTP"}</h1>

            {error && <div className="error-box">{error}</div>}

            {step === "login" ? (
              <form onSubmit={handleLogin}>
                <input
                  type="text"
                  className="input"
                  placeholder="Username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                />
                <input
                  type="password"
                  className="input"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <button type="submit" className="button-primary" disabled={authLoading}>
                  {authLoading ? "Logging in..." : "Login"}
                </button>
              </form>
            ) : (
              <form onSubmit={handleOtpVerify}>
                <input
                  type="text"
                  className="input"
                  placeholder="Enter OTP"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  required
                />
                <button type="submit" className="button-primary" disabled={authLoading}>
                  {authLoading ? "Verifying..." : "Verify OTP"}
                </button>
              </form>
            )}
          </div>
          <div className="legal-links">
            <a href="/privacy" target="_blank">Privacy Policy</a>
            <span> | </span>
            <a href="/terms" target="_blank">Terms & Conditions</a>
            </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
 